<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  [id]="'transactions-' + scheduledMessageId"
  (onAdd)="onCreate()"
  (sortObject)="getSortItems($event)"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (onShowAuditPage)="onShowAuditPage()"
  (onShowHelpPage)="onShowHelpPage()"
>
  <div class="card-toolbar" after-btns>
    <!-- scheduledMessageId -->
    <div class="tw-flex tw-justify-between tw-items-center tw-ml-5">
      <span
        class="tw-font-medium tw-text-base tw-text-gray-700 dark:tw-text-gray-300"
        >{{ "common.scheduledMessageId" | translate }} :
      </span>
      <span
        copyToClipboard
        class="text-navyBlue tw-py-1 rounded tw-text-xl tw-mr-2 tw-font-semibold"
        >{{ scheduledMessageId }}</span
      >
    </div>

    <!-- refresh btn -->
    <a
      type="button"
      class="btn btn-light txt-lg button-shadow tw-mx-2 tw-flex tw-items-center text-blue"
      mat-ripple
      [matTooltip]="'common.refresh' | translate"
      (click)="getData()"
    >
      <mat-icon class="dark:tw-text-gray-300">refresh</mat-icon>
    </a>
  </div>

  <!--------------------------------------------------------------- Table Content ---------------->
  <ng-container table-body *ngIf="items?.length && !pageConfig.loading">
    <ng-container *ngFor="let item of items; let i = index">
      <tr>
        <!-- index -->
        <td class="tw-text-center !tw-p-4">{{ i + 1 }}</td>

        <!-- amount -->
        <td class="tw-py-5">
          <td-value
            class="tw-font-semibold"
            copyToClipboard
            type="number"
            [value]="item?.amount"
          ></td-value>
        </td>

        <!-- currentCredit -->

        <td class="tw-py-5">
          <span
            copyToClipboard
            [class]="fontSize == 'sm' ? 'tw-text-[11px]' : 'tw-text-[12px]'"
            [credit]="item?.currentCredit | numberSeparator"
            >{{ item?.currentCredit | numberSeparator }}</span
          >
        </td>

        <!-- typeTransaction -->
        <td class="dir-ltr tw-py-3">
          <span
            *ngIf="item?.typeTransaction === TypeTransactions.Increase"
            class="text-success tw-font-semibold"
          >
            <i
              class="mdi mdi-arrow-up mdi-20px text-success"
              [matTooltip]="
                item?.typeTransaction | enumToText : TypeTransactionsEnumValues
              "
            ></i>
          </span>
          <span
            *ngIf="item?.typeTransaction === TypeTransactions.Decrease"
            class="text-danger tw-font-semibold"
          >
            <i
              class="mdi mdi-arrow-down mdi-20px text-danger"
              [matTooltip]="
                item?.typeTransaction | enumToText : TypeTransactionsEnumValues
              "
            ></i>
          </span>
        </td>

        <!-- typeCreditChange -->
        <td class="dir-ltr tw-py-5">
          <span>{{
            item?.typeCreditChange | enumToText : TypeCreditChangesEnumValues
          }}</span>
        </td>

        <!-- userName -->
        <td class="tw-py-2">
          <td-value copyToClipboard [value]="item?.userName"></td-value>
        </td>

        <!-- organizationName -->
        <td class="tw-py-5">
          <td-value copyToClipboard [value]="item?.organizationName"></td-value>
        </td>

        <!-- description -->
        <td
          class="msg-summary tw-text-center"
          [ngClass]="{
            ' tw-cursor-pointer': item?.description
          }"
        >
          <div
            class="tw-flex-center"
            textPopover
            [selectorType]="'id'"
            [parentSelector]="'transactions-' + scheduledMessageId"
            [fullText]="item?.description"
            [hidePopover]="
              !showParent ||
              pageConfig?.isVisibleHelpPage ||
              pageConfig?.isVisibleAuditPage
            "
          >
            <p
              class="tw-text-gray-500 dark:!tw-text-gray-200 tw-font-normal max-one-row tw-w-[100px] tw-min-w-[100px]"
            >
              {{ item?.description | checkValue }}
            </p>
          </div>
        </td>

        <!-- created -->
        <td>
          <td-value
            type="dateTimeWithSecond"
            [value]="item?.createdAt"
          ></td-value>
        </td>
        
      </tr>
    </ng-container>
  </ng-container>
</app-page-template>

<!--------------------------------------------------------------- help ---------------->
<ng-container *ngIf="pageConfig?.isVisibleHelpPage">
  <app-help-page
    [menuTitle]="pageName"
    (hidePage)="onHideHelpPage()"
    [title]="pageConfig.title"
  >
  </app-help-page>
</ng-container>
